import { Button } from "@mui/material";
import DownloadForOfflineRoundedIcon from "@mui/icons-material/DownloadForOfflineRounded";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import { Box } from "@mui/system";
import React, { useState } from "react";
import toast from "react-hot-toast";
import { emailexportToExcel } from "../../api";
import { saveAs } from "file-saver";

function EmailExcelExport({ filtering }) {
  const [isLoadingExcelData, setIsLoadingExcelData] = useState(false);

  const handleExportData = async () => {
    setIsLoadingExcelData(true);

    let response = await emailexportToExcel(filtering);

    if (response.status !== "error") {
      toast.success("Export completed. You’ll receive an email with the download link shortly.", {
        duration: 6000 // duration in milliseconds (e.g., 5 seconds)
      });
    } else {
      toast.error("Export failed. Please try again later.");
    }

    setIsLoadingExcelData(false);
  };

  return (
    <Box>
      <Button
        sx={{
          color: "#ffff",
          height: "33px",
          backgroundColor: "#76b900",
          width: "200px",
        }}
        className="sc-eqUAAy grpoRq kaizen-button rectangle regular primary solid"
        size="small"
        variant="filled"
        onClick={isLoadingExcelData ? null : handleExportData}
      >
        <EmailRoundedIcon />
        {isLoadingExcelData ? "Loading..." : "Email Excel"}
      </Button>
    </Box>
  );
}

export default EmailExcelExport;
